import { Select } from "antd";
import React, { useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";

const LanguageField = ({
  language,
  register,
  errors,
  setValue,
  getValues,
  trigger,
  labelTxt = "Languages Known",
  registerContent = "languages_known",
  placeholder = "Select your known languages",
  multiSelectClassName = "dynamic-languages",
  multiSelectWrapperClassName = "col-md-6",
  labelClassName = "title",
  validation = "known Languages",
  selectedLang = [],
}) => {
  useEffect(() => {
    if (
      getValues()?.[registerContent]?.length &&
      typeof getValues()?.[registerContent][0] === "string"
    ) {
      const selectedlanguages = getValues()?.[registerContent]?.map((data) => ({
        value: data,
        label: data,
      }));

      setValue(registerContent, selectedlanguages);
    }
  }, [getValues().languages_known]);

  const handleChange = (selectedOptions) => {
    setValue(registerContent, selectedOptions);
    trigger();
  };

  const options = language
    .filter((el) => el.active)
    .map((el) => ({
      value: el.type,
      label: el.type,
    }));

  // Safely get the current values
  const currentValues = getValues()?.[registerContent] || [];
  const selectedValues = Array.isArray(currentValues)
    ? currentValues.map((item) => item?.value || item).filter(Boolean)
    : [];

  return (
    <div className={`col-12 ${multiSelectWrapperClassName} mb-40`}>
      <label className={`form-label ${labelClassName}`}>
        {labelTxt} <span className="star">*</span>
      </label>
      <Select
        suffixIcon={<IoIosArrowDown size={18} />}
        size={"large"}
        mode="multiple"
        allowClear
        style={{ width: "100%" }}
        placeholder={placeholder}
        onChange={handleChange}
        options={options}
        value={selectedValues}
        className={multiSelectClassName}
        maxTagCount={3}
        maxTagTextLength={10}
        maxTagPlaceholder={(omittedValues) => `+ ${omittedValues.length} more`}
      />
      {!selectedValues.length && errors[registerContent] && (
        <div className="invalid-feedback d-block">
          Please provide a {validation}
        </div>
      )}
    </div>
  );
};

export default LanguageField;
